import React from 'react'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import DataPanel from 'components/theme/DataPanel'
import { createSelector } from 'reselect'

const totalInProgress = createSelector(
  (state) => state.data.campaign || {},
  (campaigns) =>
    Object.values(campaigns).reduce((inProgress, campaign) => {
      if (campaign.status === 'L') inProgress += 1
      return inProgress
    }, 0),
)
const totalCompleted = createSelector(
  (state) => state.data.campaign || {},
  (campaigns) =>
    Object.values(campaigns).reduce((completed, campaign) => {
      if (campaign.status === 'C') completed += 1
      return completed
    }, 0),
)

export default connect(
  (state) => ({
    campaignCount: Object.keys(state.data.campaign || {}).length,
    totalCompleted: totalCompleted(state),
    totalInProgress: totalInProgress(state),
    totalTaskCount: Object.values(state.data.campaign || {}).reduce(
      (acc, campaign) => {
        if (campaign.stages) {
          const count = campaign.stages.reduce((taskCount, stage) => {
            if (stage.tasks) {
              taskCount += stage.tasks.length
            }
            return taskCount
          }, 0)

          acc += count
        }
        return acc
      },
      0,
    ),
  }),
  null,
)(({ campaignCount, totalCompleted, totalInProgress, totalTaskCount }) => (
  <Grid container spacing={16}>
    <Grid item xs={3}>
      <DataPanel
        value={
          totalCompleted
            ? Math.round((totalCompleted / campaignCount) * 100)
            : null
        }
        property="Completed"
        arcGauge
        color="green"
        label={`${totalCompleted} Total Completed`}
      />
    </Grid>
    <Grid item xs={3}>
      <DataPanel
        value={
          totalInProgress
            ? Math.round((totalInProgress / campaignCount) * 100)
            : null
        }
        property="In-Progress"
        arcGauge
        color="orange"
        label={`${totalInProgress} Total In-Progress`}
      />
    </Grid>
    <Grid item xs={3}>
      <DataPanel value={campaignCount} color="pink" label="Total Campaigns" />
    </Grid>
    <Grid item xs={3}>
      <DataPanel
        value={totalTaskCount}
        color="blue"
        label={`Total Campaign Task${totalTaskCount === 1 ? '' : 's'}`}
      />
    </Grid>
  </Grid>
))
